import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../util/assets';

const propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  withIcon: PropTypes.bool,
  brandColor: PropTypes.bool,
  className: PropTypes.string,
};

const WaldoProductLogo = ({
  type,
  size,
  withIcon,
  brandColor,
  className,
  ...props
}) => {
  const classes = classNames({
    'logo-product': true,
    'logo-product-sm': size === 'sm',
    'logo-product-lg': size === 'lg',
    'logo-product-brand-color': brandColor,
    [className]: !!className,
  });

  return (
    <div className={classes} {...props}>
      {withIcon && (
        <img
          className="logo-product-icon"
          src={getAsset('/waldo-icon.svg')}
          alt="Waldo Icon"
        />
      )}
      <span className="logo-product-brand">waldo</span>
      {type && <span className="logo-product-desc">{type}</span>}
    </div>
  );
};

WaldoProductLogo.propTypes = propTypes;

export default WaldoProductLogo;
